// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import './assets/main.css'
import '../node_modules/de-zurich-ui-library/dist/de-zurich-ui-library.css'

// https://github.com/LeSuisse/vue-dompurify-html/tree/main/packages/vue-dompurify-html
import VueDOMPurifyHTML from 'vue-dompurify-html'
import { type App, createApp, h, reactive } from 'vue'
import { createPinia } from 'pinia'

import { type Config } from '../public/type.customerportal'
import type { KeycloakInstance } from 'keycloak-js'
import i18n from './i18n'
import Kundenportal from './Kundenportal.vue'
import Helpdesk from './Helpdesk.vue'
import { router } from './router/router'
import { getBasePath } from './utils/utils'
import { initGoogleTagManager } from './utils/gtm'
import { isLaunchedAsInstalledPwa, registerPwa } from './pwa'

;(async () => {
  const baseUrl = getBasePath()
  const props = reactive({ loadPortal: false })

  const purifyOptions = {
    ALLOWED_ATTR: ['class', 'href', 'rel', 'style', 'target', 'title'],
    ALLOWED_TAGS: [
      'a',
      'b',
      'br',
      'em',
      'i',
      'li',
      'ol',
      'p',
      'span',
      'strong',
      'u',
      'ul'
    ]
  }

  let app: App

  if (import.meta.env.MODE === 'helpdesk') {
    app = createApp({
      render: () => h(Helpdesk, props)
    })

    app.config.globalProperties.window = globalThis

    await import(/* @vite-ignore */ `${baseUrl}/config.helpdesk.js`).then((mod) => {
      app.config.globalProperties.window.ENV_CONFIG = mod.config
    })
  } else {
    app = createApp({
      render: () => h(Kundenportal, props)
    })

    app.config.globalProperties.window = globalThis

    await import(/* @vite-ignore */ `${baseUrl}/config.customerportal.js`).then((mod) => {
      app.config.globalProperties.window.ENV_CONFIG = mod.config
    })

    console.log('App als installierte PWA gestartet:', isLaunchedAsInstalledPwa())

    if (globalThis.ENV_CONFIG.FEATURE_FLAGS.PWA?.ENABLE_INSTALLATION) {
      registerPwa()
    }

    initGoogleTagManager()
  }

  app.use(router)
  app.use(i18n)
  app.use(VueDOMPurifyHTML, { default: purifyOptions })
  app.use(createPinia())
  props.loadPortal = true
  const cpContainer =
    globalThis.document.querySelector('#cp') ??
    globalThis.document.querySelector('#host')?.shadowRoot?.querySelector('#cp')
  app.mount(cpContainer)
})()

declare global {
  interface Window {
    ENV_CONFIG: Config
    keycloak: KeycloakInstance
  }

  var ENV_CONFIG: Config
  var keycloak: KeycloakInstance
}
